import { render, staticRenderFns } from "./JdsNavigatorBadge.vue?vue&type=template&id=650af16f&"
import script from "./JdsNavigatorBadge.vue?vue&type=script&lang=ts&"
export * from "./JdsNavigatorBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports